import { WidgetProps } from '@highimpact-front/remote-widget-core';
import type { ApiReturnSite } from '@highimpact-frontend/api-types';
import {
  widget_configurations,
  WidgetNameType,
  WidgetParamsFromName,
  WidgetType,
} from '../../../../state/dashboard/widget';
import type { FunctionComponent } from 'react';
import { createElement, forwardRef, type LegacyRef } from 'react';
import Widget from '../../commons/Widget';

interface GroupProps extends WidgetProps {
  widgets: Record<string, WidgetType>;
}

// TODO: move to utility file

interface CreateWidgetElementProps<T extends WidgetNameType> {
  widget_id: string;
  dashboardElementId: number;
  site?: ApiReturnSite;
  is_editable: boolean;
  props: WidgetParamsFromName<T>;
}

function createWidgetElement<T extends WidgetNameType>(
  type: T,
  params: CreateWidgetElementProps<T>
) {
  return createElement(
    widget_configurations[type].component as unknown as FunctionComponent<
      WidgetParamsFromName<T>
    >,
    {
      key: params.widget_id,
      widget_id: params.widget_id,
      dashboardElementId: params.dashboardElementId,
      site: params.site,
      is_editable: params.is_editable,
      ...params.props,
    }
  );
}

function GroupWidget(
  { site, widgets, ...props }: GroupProps,
  ref: LegacyRef<HTMLDivElement>
) {
  return (
    <Widget
      ref={ref}
      site={site}
      {...props}
      className={`group ${props.className || ''}`}
    >
      {[...Object.entries(widgets)].map(
        ([widget_id, { type, props: widgetProps, dashboardElementId }]) => {
        if (!widget_configurations[type]) {
          throw new Error(`Unknown widget type: ${String(type)}`);
        }

        return createWidgetElement(type, {
          widget_id,
          dashboardElementId,
          site,
          is_editable: Boolean(widgetProps.is_editable),
          props: widgetProps,
        });
      })}
    </Widget>
  );
}

export default forwardRef(GroupWidget);
